import React, { useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";
import { useBannerTexture } from "../hooks";
import { COLORS } from "../constants";

function Banner({ position, rotation = [0, 0, 0] }) {
  const tex = useBannerTexture();
  const ref = useRef();
  useFrame((state) => {
    if (ref.current) {
      ref.current.rotation.z =
        Math.sin(state.clock.elapsedTime * 0.6 + position[0]) * 0.04;
    }
  });
  return (
    <group position={position} rotation={rotation}>
      <mesh castShadow position={[0, 4, 0]}>
        <cylinderGeometry args={[0.08, 0.1, 8, 8]} />
        <meshStandardMaterial color={COLORS.navyDeep} metalness={0.5} roughness={0.5} />
      </mesh>
      <mesh position={[0, 8.1, 0]}>
        <sphereGeometry args={[0.18, 12, 12]} />
        <meshStandardMaterial color={COLORS.gold} metalness={0.8} roughness={0.3} />
      </mesh>
      <group ref={ref} position={[0, 6.5, 0]}>
        <mesh position={[0.85, -1.0, 0]}>
          <planeGeometry args={[1.7, 2.6]} />
          <meshStandardMaterial map={tex} roughness={0.8} side={THREE.DoubleSide} />
        </mesh>
        <mesh position={[0.85, 0.2, 0]} rotation={[0, 0, Math.PI / 2]}>
          <cylinderGeometry args={[0.04, 0.04, 1.9, 8]} />
          <meshStandardMaterial color={COLORS.gold} metalness={0.7} />
        </mesh>
      </group>
    </group>
  );
}

export default function Banners() {
  return (
    <group>
      <Banner position={[8, 0, 8]} />
      <Banner position={[-8, 0, 8]} rotation={[0, Math.PI, 0]} />
      <Banner position={[8, 0, -8]} />
      <Banner position={[-8, 0, -8]} rotation={[0, Math.PI, 0]} />
    </group>
  );
}
